module.exports = __webpack_public_path__ + "img/caution.c6f02fc4.svg";